import { useMutation } from "@tanstack/react-query";
import { createCoachingNote, type ApiError } from "@/lib/api";
import { invalidateScope } from "@/lib/queryClient";
import type { CoachingNote, CreateCoachingNoteRequest } from "@/lib/types";

export function useQuickFeedback() {
  return useMutation<
    { note: CoachingNote },
    ApiError,
    CreateCoachingNoteRequest
  >({
    mutationFn: createCoachingNote,
    onSuccess: () => invalidateScope(),
  });
}
